module.exports = __webpack_public_path__ + "img/close.c28c27a8.svg";